<mat-card *ngIf="editVehicleData" class="vehicle-card">
  <form #vehicleForm="ngForm">

    <!-- HEADER -->
    <mat-toolbar class="vehicle-toolbar">
      <span style="width:90%">Vehicle</span>
      <span class="fill-remaining-space"></span>
      <div class="toolbar-actions">
        <button mat-icon-button (click)="assignOwners(editVehicleData.plate)" matTooltip="Add owner">
          <mat-icon>add</mat-icon>
        </button>
        <button mat-icon-button (click)="desar()" matTooltip="Desar">
          <mat-icon>save</mat-icon>
        </button>
        <button mat-icon-button (click)="close()" matTooltip="Tancar">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </mat-toolbar>

    <!-- CONTINGUT -->
    <div class="vehicle-content">

      <!-- FORMULARI -->
      <div class="vehicle-form">

  <!-- ========================================================= -->
  <!-- BASIC INFORMATION -->
  <!-- ========================================================= -->

  <div class="section-title">
    Basic information
  </div>

  <mat-form-field appearance="outline">
    <mat-label>Plate</mat-label>
    <input
      matInput
      name="plate"
      [(ngModel)]="editVehicleData.plate"
      [matAutocomplete]="autoPlate"
      required>
  </mat-form-field>

  <mat-autocomplete #autoPlate="matAutocomplete">
    <mat-option *ngFor="let plate of plateList" [value]="plate.value">
      {{ plate.text }}
    </mat-option>
  </mat-autocomplete>

  <mat-form-field appearance="outline">
    <mat-label>Chassis number (VIN)</mat-label>
    <input
      matInput
      name="vin"
      [(ngModel)]="editVehicleData.vin"
      [matAutocomplete]="autoVin">
  </mat-form-field>

  <mat-autocomplete #autoVin="matAutocomplete">
    <mat-option *ngFor="let v of vinList" [value]="v.value">
      {{ v.text }}
    </mat-option>
  </mat-autocomplete>

  <mat-form-field appearance="outline">
    <mat-label>Manufacturer</mat-label>
    <mat-select
      name="manufacturer"
      [(ngModel)]="editVehicleData.manufacturer">

      <mat-option
        *ngFor="let m of manufacturers"
        [value]="m.value">
        {{ m.text }}
      </mat-option>

    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Model</mat-label>
    <input
      matInput
      name="model"
      [(ngModel)]="editVehicleData.model">
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Year manufacture</mat-label>
    <input
      matInput
      type="number"
      name="year_manufacture"
      [(ngModel)]="editVehicleData.year_manufacture">
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Colour</mat-label>
    <mat-select
      name="colour"
      [(ngModel)]="editVehicleData.colour">

      <mat-option
        *ngFor="let c of colors"
        [value]="c.value">
        {{ c.text }}
      </mat-option>

    </mat-select>
  </mat-form-field>

  <!-- ========================================================= -->
  <!-- CLASSIFICATION -->
  <!-- ========================================================= -->

  <div class="section-title">
    Classification
  </div>

  <mat-form-field appearance="outline">
    <mat-label>Category</mat-label>
    <mat-select
      name="category"
      [(ngModel)]="editVehicleData.category"
      (selectionChange)="categoryChanged($event.value)">
      <mat-option
        *ngFor="let c of categories"
        [value]="c.value">
        {{ c.text }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Subcategory</mat-label>
    <mat-select
      name="subcategory"
      [(ngModel)]="editVehicleData.subcategory">
      <mat-option
        *ngFor="let s of filteredSubcategories"
        [value]="s.value">
        {{ s.text }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <!-- ========================================================= -->
  <!-- ENGINE -->
  <!-- ========================================================= -->

  <div class="section-title">
    Engine specification
  </div>

  <mat-form-field appearance="outline">
    <mat-label>Fuel</mat-label>

    <mat-select
      name="fuel"
      [(ngModel)]="editVehicleData.fuel">
      <mat-option
        *ngFor="let f of fuels"
        [value]="f.value">
        {{ f.text }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field
      appearance="outline"
      *ngIf="editVehicleData.fuel=='Hybrid'">
      <mat-label>Hybrid type</mat-label>
      <mat-select
          name="hybrid_type"
          [(ngModel)]="editVehicleData.hybrid_type">
          <mat-option
              *ngFor="let h of hybridTypes"
              [value]="h.value">
              {{h.text}}
          </mat-option>
      </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Engine number</mat-label>

    <input
      matInput
      name="engine_num"
      [(ngModel)]="editVehicleData.engine_num">
  </mat-form-field>

  <mat-form-field
      appearance="outline"
      *ngIf="editVehicleData.fuel=='Electric'">

      <mat-label>Battery number</mat-label>

      <input
          matInput
          name="battery_num"
          [(ngModel)]="editVehicleData.battery_num">

  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Capacity (cc or kW)</mat-label>

    <input
      matInput
      type="number"
      name="engine"
      [(ngModel)]="editVehicleData.engine">
  </mat-form-field>

  <mat-form-field
      appearance="outline"
      *ngIf="editVehicleData.category=='Van'
          || editVehicleData.category=='Truck'">

      <mat-label>Cubic capacity</mat-label>

      <input
          matInput
          type="number"
          name="cc"
          [(ngModel)]="editVehicleData.cc">

  </mat-form-field>

  <mat-form-field
      appearance="outline"
      *ngIf="editVehicleData.category=='Truck'">

      <mat-label>Number of wheels</mat-label>

      <input
          matInput
          type="number"
          name="wheels_num"
          [(ngModel)]="editVehicleData.wheels_num">

  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Passenger capacity</mat-label>

    <input
      matInput
      type="number"
      name="passenger_num"
      [(ngModel)]="editVehicleData.passenger_num">
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Vehicle length (m)</mat-label>

    <input
      matInput
      type="number"
      step="0.01"
      name="length"
      [(ngModel)]="editVehicleData.length">
  </mat-form-field>

</div>

      <!-- TARGETA VISUAL -->
      <div class="vehicle-preview">
        <img src="assets/imatges/grenada_vehicles.png" alt="Vehicles">
        <h3>{{ editVehicleData.plate || '—' }}</h3>
        <p>{{ editVehicleData.manufacturer }} {{ editVehicleData.model }}</p>
      </div>

    </div>

  </form>
</mat-card>
